<script>
  export let commentaryText = '';
  export let ballType = 'dot'; // 'four', 'six', 'wicket', 'wide', 'nb', 'dot'

  $: commentatorBadge = (() => {
    if (!commentaryText) return null;
    if (commentaryText.includes('Aakash Chopra')) return { name: 'Aakash Chopra', color: '#3b82f6' };
    if (commentaryText.includes('Ravi Shastri')) return { name: 'Ravi Shastri', color: '#10b981' };
    if (commentaryText.includes('Sidhu')) return { name: 'Navjot Sidhu', color: '#f59e0b' };
    return null;
  })();

  $: displayText = commentaryText
    .replace(/^Aakash Chopra style:\s*/, '')
    .replace(/^Ravi Shastri style:\s*/, '')
    .replace(/^Sidhu style:\s*/, '');
</script>

{#if commentaryText}
  <div class="commentary-ticker glass-card">
    <div class="ticker-content">
      <span class="mic-icon">
        🎙️ LIVE
        <span class="audio-equalizer" title="AI Commentary Audio Active">
          <span class="bar bar-1"></span>
          <span class="bar bar-2"></span>
          <span class="bar bar-3"></span>
          <span class="bar bar-4"></span>
        </span>
      </span>

      {#if commentatorBadge}
        <span class="commentator-tag" style="background: {commentatorBadge.color}22; color: {commentatorBadge.color}; border: 1px solid {commentatorBadge.color}44;">
          🗣️ {commentatorBadge.name}
        </span>
      {/if}

      {#if ballType === 'four'}<span style="color:#f97316; font-weight:800;">[4]</span>{/if}
      {#if ballType === 'six'}<span style="color:#fbbf24; font-weight:800;">[6]</span>{/if}
      {#if ballType === 'wicket'}<span style="color:#ef4444; font-weight:800;">[W]</span>{/if}

      <span class="ticker-text">{displayText}</span>
    </div>
  </div>
{/if}

<style>
  .commentary-ticker {
    display: flex;
    align-items: center;
    background: rgba(15, 23, 42, 0.85);
    backdrop-filter: blur(14px);
    border: 1px solid rgba(59, 130, 246, 0.25);
    border-radius: 10px;
    padding: 9px 12px;
    margin: 0;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
    animation: ticker-slide-in 0.3s cubic-bezier(0.32, 0.72, 0, 1);
  }
  .ticker-content {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 12px;
    color: #f8fafc;
    width: 100%;
    overflow: hidden;
  }
  .mic-icon {
    font-weight: 900;
    color: #10b981;
    font-size: 10px;
    letter-spacing: 1px;
    flex-shrink: 0;
    background: rgba(16, 185, 129, 0.15);
    padding: 3px 8px;
    border-radius: 999px;
    border: 1px solid rgba(16, 185, 129, 0.3);
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }
  .audio-equalizer {
    display: inline-flex;
    align-items: flex-end;
    gap: 2px;
    height: 10px;
    vertical-align: middle;
  }
  .audio-equalizer .bar {
    width: 2px;
    background: #10b981;
    border-radius: 2px;
    animation: eq-pulse 0.55s infinite ease-in-out alternate;
  }
  .audio-equalizer .bar-1 { height: 40%; animation-delay: 0.0s; }
  .audio-equalizer .bar-2 { height: 100%; animation-delay: 0.15s; }
  .audio-equalizer .bar-3 { height: 60%; animation-delay: 0.30s; }
  .audio-equalizer .bar-4 { height: 85%; animation-delay: 0.45s; }

  @keyframes eq-pulse {
    0% { height: 25%; opacity: 0.4; }
    50% { height: 100%; opacity: 1; }
    100% { height: 35%; opacity: 0.6; }
  }
  .commentator-tag {
    font-size: 10px;
    font-weight: 800;
    padding: 2px 8px;
    border-radius: 6px;
    flex-shrink: 0;
    letter-spacing: 0.2px;
  }
  .ticker-text {
    font-weight: 600;
    line-height: 1.35;
    white-space: normal;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    color: #e2e8f0;
    min-width: 0;
  }

  @media (max-width: 560px), (max-height: 520px) {
    .commentary-ticker { padding: 7px 9px; }
    .ticker-content { gap: 6px; font-size: 11px; }
    .commentator-tag { display: none; }
  }

  @keyframes ticker-slide-in {
    from { opacity: 0; transform: translateY(-6px); }
    to { opacity: 1; transform: translateY(0); }
  }
</style>
